import { call, put, select } from 'redux-saga/effects'

import { ARBITER_TAG } from 'common/tags'

import { creators } from 'common/modules/arbiter/actions'

function* init(params, {
    payload: {
        tag,
        xprops: {
            content,
        } = {},
    },
}) {
    try {
        if (tag !== ARBITER_TAG || !content) {
            return
        }

        const { loader } = yield select()
        const scope = loader.user ? 'user' : 'guest'

        yield put(
            yield call(
                creators.invalidationEvent,
                {
                    payload: {
                        scope: [
                            scope,
                        ],
                        executePostLoaderActions: true,
                    },
                },
            ),
        )
    } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error(error)
    }
}

export default init
